import { connect } from "react-redux";
import * as transactionActions from "./actions";

//Used to format the dates correctly without timezone (ToDo add this globally somehow?)
import moment from "moment";

function mapStateToProps(state) {
  return {
    transactions: state.transactions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getTransactions: (from, to) => {
      to = moment(to).format("YYYY-MM-DD");
      from = moment(from).format("YYYY-MM-DD");
      dispatch(transactionActions.get_transactions(from, to));
    },

    getTransactionsForDepot: (depotId, from, to, investorId) => {
      to = moment(to).format("YYYY-MM-DD");
      from = moment(from).format("YYYY-MM-DD");
      dispatch(
        transactionActions.get_transactions_for_depot(
          depotId,
          from,
          to,
          investorId,
        ),
      );
    },

    changeTransactionListPage: (page) => {
      dispatch(transactionActions.change_transaction_list_page(page));
    },

    changeTransactionListFilter: (type, key, value) => {
      dispatch(transactionActions.change_transaction_list_filter(key, value));
    },

    changeTransactionListFilterDate: (key, value) => {
      dispatch(
        transactionActions.change_transaction_list_filter_date(key, value),
      );
    },
  };
}

export const transactionConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
